import { Component, ReactNode } from "react";
import { NWSVolumeRouterProps } from "../NWSVolumeRouterProps";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NWSVolumeLayout } from "../NWSVolumeLayout";
import { NWSVolumeEntities } from "../NWSVolumeEntities";

export interface VolumeViewPageProps extends NSARouterMakerResult, NWSVolumeRouterProps { }

class VolumeViewPage extends Component<VolumeViewPageProps>
{
    override render(): ReactNode
    {
        return (
            <NWSVolumeLayout
                {...this.props}
                pages={{
                    entity: NWSVolumeEntities.volume(this.props),
                    view: {}
                }}
            >
                <></>
            </NWSVolumeLayout>
        );
    }
}

export default VolumeViewPage;